import { z } from "zod";

// GET …/tenants/{tenantId}/settings. Only the fields the client needs.
export const coreTenantSettingsSchema = z.object({
    data: z.object({
        currencyCode: z.string().nullable().optional()
    })
});
